import { useLayoutEffect } from 'react';

export const MOBILE_WORKBENCH_SHEET_OPEN_CLASS = 'app-mobile-workbench-sheet-open';

let openSheetCount = 0;

/** 手机工作台底部 Sheet 打开时：隐藏底部按钮岛、锁定底层滚动 */
export const useMobileWorkbenchSheetOpen = (isOpen) => {
	useLayoutEffect(() => {
		if (!isOpen) {
			return undefined;
		}

		openSheetCount += 1;
		if (openSheetCount === 1) {
			document.body.classList.add(MOBILE_WORKBENCH_SHEET_OPEN_CLASS);
		}

		return () => {
			openSheetCount = Math.max(0, openSheetCount - 1);
			if (openSheetCount === 0) {
				document.body.classList.remove(MOBILE_WORKBENCH_SHEET_OPEN_CLASS);
			}
		};
	}, [isOpen]);
};
